import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { API_MAP } from 'app/core/helpers/api.map';
import { map } from 'rxjs';
import { DoctorService } from './doctor.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const DoctorResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(DoctorService)
    .get(API_MAP.doctor + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
